import React, { useEffect } from 'react'
import Footer from "../Components/Footer/Footer";
import Navigation from "../Components/Navbar/Navigation";
import GoldBanner from "../Components/Property/GoldBanner";
import GoldContent from "../Components/Property/GoldContent";
export default function Gold() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <div className="innerpages-nav">
       <div id="container">
      <Navigation />
      <GoldBanner />
      <GoldContent />
      <Footer />
      </div>
    </div>
  );
}
